// import { storeStructure } from '../store/reducers';
import tableLiveDeployment from './tableLiveDeploymentItems';
import tableLiveSettings from './tableLiveSettings';
export default {
  title: 'Live Settings',
  attributeName: "liveSettings",
  getURL: 'livesettings',
  createURL: 'livesettings',
  // updateURL: 'livedeploymentsmultiple',
  removeURL: 'livesettings',
  sessionParams: [],
  // websocketEventChanel:"liveDeployment",
  // websocketItem: 'liveDeployment',
  noArea: true,
  tableConfig: tableLiveSettings,
  autoUpdate: true,
};
